module.exports = __webpack_public_path__ + "static/media/xls.327ef532.svg";